import api from "./client";

// список
export const getIncidents = () =>
  api.get("/api/incidents/");

// один
export const getIncident = (id) =>
  api.get(`/api/incidents/${id}/`);

// создать
export const createIncident = (data) =>
  api.post("/api/incidents/", data);

// отправить
export const sendIncident = (id) =>
  api.post(`/api/incidents/${id}/send/`);

// аналитика
export const getIncidentStats = () =>
  api.get("/api/incidents/stats/");

export const updateIncident = (id, data) =>
  api.put(`/api/incidents/${id}/`, data);

export const deleteIncident = (id) =>
  api.delete(`/api/incidents/${id}/`);
